interface SwiperControlsProps {
    id: string
    className?: string
    showNavigationPrev?: boolean
    showNavigationNext?: boolean
    showPagination?: boolean
}

export const swiperNavigationOptions = {
    disabledClass: 'swiper-navigation__button--disabled',
    lockClass: 'swiper-navigation__button--lock',
}

export const swiperPaginationOptions = {
    paginationDisabledClass: 'swiper-pagination--disabled',
    bulletClass: 'swiper-pagination__bullet',
    bulletActiveClass: 'swiper-pagination__bullet--active',
    lockClass: 'swiper-pagination--lock',
    clickable: true,
    bulletElement: 'button',
}

const SwiperControls = ({
    id: id,
    className = '',
    showNavigationPrev = true,
    showNavigationNext = true,
    showPagination = true,
}: SwiperControlsProps) => {
    const classNavigationPrev = `swiper-navigation__button swiper-navigation__button-prev swiper-navigation__button-prev-${id}`
    const classNavigationNext = `swiper-navigation__button swiper-navigation__button-next swiper-navigation__button-next-${id}`
    const classPagination = `swiper-pagination swiper-pagination-${id}`

    return (
        <div className={`swiper-controls ${className}`}>
            {showNavigationPrev && <button className={classNavigationPrev} aria-label={`{{js.swiper.controls.navigation.button.prev.aria-label}}`}></button>}
            {showPagination && <nav className={classPagination}></nav>}
            {showNavigationNext && <button className={classNavigationNext} aria-label={`{{js.swiper.controls.navigation.button.next.aria-label}}`}></button>}
        </div>
    )
}

export default SwiperControls
